import { render, staticRenderFns } from "./Onboarding-old.vue?vue&type=template&id=6a924012&"
import script from "./Onboarding-old.vue?vue&type=script&lang=js&"
export * from "./Onboarding-old.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding-old.vue?vue&type=style&index=0&id=6a924012&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports